import {
  Component,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { GtwElementsBaseUrlsModel } from '../../../shared/_models/gtw-elements-base-urls.model';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
  buildHeaderDataShell,
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-efile-scrubbing-confirmation',
    templateUrl: './scrubbing-confirmation.component.html',
    styleUrls: ['./scrubbing-confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ScrubbingConfirmationComponent implements OnInit, OnDestroy {
  private readonly subs = new Subscription();

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  private isInitialized = false;

  baseURLs: GtwElementsBaseUrlsModel = { admin: '', api: '', custom: '', efile: '', pdfEngine: '', bulkPdfEngine: '' };
  headerData: any = {};
  globalService: any = {};
  rowData: any = {};
  filterParams: any = {};

  gridData: any[] = [];
  gridColumns: string[] = [];
  modalTitle: string = 'Confirm Scrubbing';
  minimise: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private gtwSnackbarService: GtwSnackbarService,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
  ) { }

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => this.applyWorkspaceContext())
    );
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => this.applyWorkspaceContext())
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const gc = generalConfigFromGlobal(this.gtwGlobal);
    this.baseURLs = {
      api: gc.api,
      admin: gc.admin,
      custom: gc.custom,
      efile: gc.efile,
      pdfEngine: gc.pdfEngine,
      bulkPdfEngine: gc.bulkPdfEngine,
    };
    this.headerData = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    this.globalService = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace);
    this.rowData = rowPayloadFromActiveScreen(activeScreen);
    this.filterParams = normalizeFilterParams(activeScreen);
    this.buildGridFromRowData();
    const efileApiUrl = this.baseURLs?.efile || gc?.gtw_efile_api_url;
    if (efileApiUrl && !this.isInitialized) {
      this.isInitialized = true;
    }
    this.cdr.markForCheck();
  }

  private buildGridFromRowData(): void {
    const data = this.rowData?.gridData;
    if (!data || !Array.isArray(data)) {
      this.gridData = [];
      this.gridColumns = [];
      return;
    }
    this.gridData = data;
    if (data.length > 0) {
      const first = data[0];
      const row = first?.data != null ? first.data : first;
      this.gridColumns = Object.keys(row || {});
    } else {
      this.gridColumns = [];
    }
  }

  confirm(): void {
    this.requestGridUpdate.emit('refresh');
  }

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }
}
